import { Card } from '@stripe/stripe-js'
import { DateTime } from 'luxon'

const getExpireDate = (cardExpireYear: number, cardExpireMonth: number) => {
  const expireDate = new Date()
  expireDate.setFullYear(cardExpireYear, cardExpireMonth, 1)
  expireDate.setHours(0, 0, 0, 0)

  return expireDate
}

export const isExpiredCard = (card?: Card): boolean => {
  if (!card) return false

  const currentDate = new Date()

  const expireDate = getExpireDate(card.exp_year, card.exp_month)

  return expireDate < currentDate
}

export const isExpiringCardInDays = (card?: Card): boolean | number => {
  if (!card) return false

  const currentDate = DateTime.now()

  const expireDate = getExpireDate(card.exp_year, card.exp_month)
  const monthBeforeExpireDate = DateTime.fromJSDate(expireDate).minus({
    months: 1,
  })

  if (currentDate > monthBeforeExpireDate) {
    const endMonth = DateTime.now().endOf('month')

    const { days } = endMonth.diff(currentDate, 'days').toObject()

    return days ?? 1
  }

  return false
}
